<template>
    
    <div class="intake-view">
        <div class="card">
			<div class="card-body">
				<div class="m-sm-4">
                    <p class="lead text-center">
                        一般民眾通報受理單
                    </p>
                    
					<formsView
                        ref="formsView"
                        :mode="'create'"
                        :type="'guest'"
                        v-model="formData"
                    ></formsView>

                    <div class="text-center mt-3">
                        <button type="button"
                            @click="save"
                            class="btn btn-success w-100"
                        >送出</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import formsView from '@/views/intake/formsView.vue'
export default {
    name: 'createIntake',
    data(){
        return {
            formData:{}
        }
    },
    components: {
        formsView
    },
    methods:{
        initFromData(){
            return {
                id:null, //受理單id
                acknowledgment_serial_no:'', //受理單號
                medical_record_id:null, //病歷id
                medical_serial_no:'', //病歷編號
                species_category_id:-1, //物種類別id
                species_id:-1, //物種id
                reporter_name:'', //通報人
                reporter_type:1, //通報人類型(1:公部門,2:私人)
                same_reporter_tag:false, //同通報人 1:check
                finder:'', //拾獲人
                contact:'', //聯絡方式
                find_date:this.$shared.getCurrentDate(),  //拾獲日期
                find_addr_city:'台東縣', //拾獲城市
                find_addr_district:'池上鄉', //拾獲區域
                find_addr_address:'', //拾獲地址
                gps_lng:'', //gps lng
                gps_lat:'', //gps lat
                rescure_reason_id:-1, //救援原因id
                attacked_type_id:-1, //動物攻擊種類id
                raising_type_id:-1, //人為原因id
                description:'', //狀況描述
                accept_date:this.$shared.getCurrentDate(), //受理日期
                update_time:'', //最近一次更新時間
                status_id:1 //受理單狀態
            }
        },
        async initView(){
            this.formData = this.initFromData()
            this.$refs.formsView.initView()
        },
        async save(){
            if ( !this.$api.intake.checkIntakeModel(this.formData).status ){
                return alert(this.$api.intake.checkIntakeModel(this.formData).message)
            }
            let objFrom = new FormData()
            objFrom.append('accept_date',this.formData.accept_date)
            objFrom.append('species_category_id',this.formData.species_category_id)
            objFrom.append('species_id', this.formData.species_id)
            objFrom.append('reporter_name', this.formData.reporter_name)
            objFrom.append('reporter_type', this.formData.reporter_type)
            objFrom.append('same_reporter_tag', this.formData.same_reporter_tag)
            //處理通報人等同拾獲人資料
            objFrom.append('finder', this.formData.same_reporter_tag ? this.formData.reporter_name : this.formData.finder)
            
            objFrom.append('contact', this.formData.contact)
            objFrom.append('find_date', this.formData.find_date)
            objFrom.append('find_addr_city', this.formData.find_addr_city)
            objFrom.append('find_addr_district', this.formData.find_addr_district)
            objFrom.append('find_addr_address', this.formData.find_addr_address)
            objFrom.append('gps_lng', this.formData.gps_lng)
            objFrom.append('gps_lat', this.formData.gps_lat)
            objFrom.append('rescure_reason_id', this.formData.rescure_reason_id !== -1 ? this.formData.rescure_reason_id : '' )
            objFrom.append('attacked_type_id', this.formData.attacked_type_id !== -1 ? this.formData.attacked_type_id : '' )
            objFrom.append('raising_type_id', this.formData.raising_type_id !== -1 ? this.formData.raising_type_id : '' )

            objFrom.append('description', this.formData.description )

            objFrom.append('status_id', 1 )

            //開始呼叫API
            this.$store.state.loadingStatus = true
            const res = await this.$api.intake.addAknowledgmentForm(objFrom)
            this.$store.state.loadingStatus = false
            if ( res.code !== 200 ){
                this.$store.state.actionResult.show({status:'fail',massage:res.msg})
                return
            }
            this.$store.state.actionResult.show({status:'success',massage:'變更成功'})
            this.formData = this.initFromData()
            this.$refs.formsView.initView()
            
            //處理重新整理前一個路由畫面
            this.$router.push(`/reportSubmitted/${res.data.serial_no}`)
        }
    },
    async mounted(){
        await this.initView()  
    },
    

}
</script>
<style scoped>
.intake-view{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 使 ::before 绝对定位相对于这个容器 */
    background-image: url('@/assets/img/wildoneHis/clouded leopard LOGO.png');
    background-repeat: no-repeat;
    background-size: 20rem;
    background-position-x: 6rem;
    background-position-y: 5rem;
    padding-top: 3rem;
}
.intake-view::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4); /* 白色半透明，調整 alpha 值以改變壓淡程度 */
    z-index: 1; /* 讓遮罩在背景圖片上 */
}

.content {
    position: relative; /* 使内容在遮罩之上 */
    z-index: 2;
}
.intake-view > .card {
    min-width: 376px;
    width: 60%;
    max-width: 1024px;
    height: fit-content;
    z-index:2;
}
.img-fluid{
    background-color: #f4f7fc;
}

@media (max-width: 768px) {
    .intake-view{
        padding-top: 9.5rem;
        background-position-x: center;
        background-position-y: 1.5rem;
    }
    .intake-view > .card[data-v-68069400] {
        min-width: 376px;
        width: 90%;
        max-width: 1024px;
        height: -moz-fit-content;
        height: fit-content;
        z-index: 2;
    }
}
</style>
  